
import { HierarchyTrail } from '../../schemas'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LowResultsHierarchy extends Vue {
  @Prop()
    hierarchyTrail: HierarchyTrail[]
}
